import React from 'react';
import './Landing.css';

function Landing() {
  return (
    <div className="landing">
      <div className="landing-container">
        <h1 className="brand-name">Apna Soundbox</h1>
        
        <p className="hero-description">
          For Indian merchants who accept UPI payments: Apna Soundbox instantly announces incoming payments aloud. No more opening multiple UPI apps to confirm—get real-time voice notifications across all major UPI apps.
        </p>

        <a 
          href="https://play.google.com/store/apps/details?id=com.apnasoundbox" 
          target="_blank" 
          rel="noopener noreferrer"
          className="cta-button"
        >
          Get the App on Google Play
        </a>

        <div className="features-section">
          <div className="feature-box">
            <h2 className="feature-title">Instant Voice Alerts</h2>
            <p className="feature-description">
              Hear "Payment received" in real time the moment the money hits—never miss a UPI payment again.
            </p>
          </div>

          <div className="feature-box">
            <h2 className="feature-title">Works with Major UPI Apps</h2>
            <p className="feature-description">
              Supports popular UPI apps—no need to keep switching between apps to check payment status.
            </p>
          </div>

          <div className="feature-box">
            <h2 className="feature-title">Simple & Reliable</h2>
            <p className="feature-description">
              Designed for speed and clarity during busy hours. Focus on customers while Apna Soundbox watches payments.
            </p>
          </div>
        </div>

        <footer className="footer">
          <p>
            © 2026 Apna Soundbox · <a href="/privacy">Privacy</a> · <a href="/terms">Terms</a> · <a href="/support">Support</a> · <a href="/delete-account">Delete account</a>
          </p>
        </footer>
      </div>
    </div>
  );
}

export default Landing;
